{
    "ConsidermovedtounresolvedasoverflowedLabel": "Considere as chamadas movidas para dispositivos não resolvidos como transbordadas:",
    "StatisticCalculations_SectionHeader": "Cálculos estatísticos",
    "StatisticCalculations_SectionPara": "É possível escolher se as chamadas são consideradas como transbordadas ou abandonadas quando a aplicação termina deliberadamente a sua modelação para chamadas movidas para localizações de dispositivos não monitorizadas ou desconhecidas.",
    "NAME": "StatisticCalculations"
}